import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({

    username: Yup.string().required("Please enter your username"),
    password: Yup.string().required("Please enter your password")
})
